import { ReactNode } from 'react';
import { useParams } from 'react-router-dom';

import { ReadRetailerNetwork } from '@occc-app/App/PolicyBasedAccessControl/userActions';

import { RetailerNetworkTobaccoPerformanceGuard } from '../guards/retailer-network-tobacco-performance.guard';
import { RetailerNetworkGuard } from '../guards/retailer-network.guard';

type RetailerNetworkTobaccoPageGuardProps = {
  children: ReactNode;
};

export const RetailerNetworkTobaccoPageGuard = ({
  children,
}: RetailerNetworkTobaccoPageGuardProps) => {
  const { networkId = '' } = useParams<{ networkId: string }>();

  return (
    <RetailerNetworkTobaccoPerformanceGuard>
      <RetailerNetworkGuard policyWithParams={ReadRetailerNetwork({ uuid: networkId })}>
        {children}
      </RetailerNetworkGuard>
    </RetailerNetworkTobaccoPerformanceGuard>
  );
};
